import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';

const pageStyles = (theme) => ({
  optionalMessage: {
    fontSize: 18,
  },
});

function FormTextField({
  label,
  helperText,
  required,
  classes,
  className,
  helperTextComponent,
  ...props
}) {
  return (
    <FormControl fullWidth={props.fullWidth} className={className}>
      <InputLabel {...props}>
        {label}{' '}
        {required ? (
          '*'
        ) : (
          <span className={classes.optionalMessage}>(optional)</span>
        )}
      </InputLabel>
      <Input {...props} />
      {helperText && (
        <FormHelperText {...props} component={helperTextComponent}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}

export default withStyles(pageStyles)(FormTextField);
